// extracted by mini-css-extract-plugin
export default {"partners":"partners_partners__y69Tj","gradient":"partners_gradient__MFiBr","carouselItem":"partners_carouselItem__ym1tJ"};